import { PersonalProfileFragment, PublicProfileFragment } from '../../../types'

export const employeeInformationComponentUiProps = (
  profile: PersonalProfileFragment | PublicProfileFragment,
): {
  isPersonalProfile: boolean
  showCitizenshipData: boolean
  showChosenFirstName: boolean
  showChosenLastName: boolean
  showAcademicTitle: boolean
  showPrivateEmailAddress: boolean
} => {
  const isPersonalProfile = profile.__typename === 'PersonalProfile'
  const showCitizenshipData = isPersonalProfile
  const showChosenFirstName = isPersonalProfile || !!(!isPersonalProfile && profile.chosenFirstName)
  const showChosenLastName = isPersonalProfile || !!(!isPersonalProfile && profile.chosenLastName)
  const showAcademicTitle = isPersonalProfile || !!(!isPersonalProfile && profile.academicTitle)
  const showPrivateEmailAddress = isPersonalProfile

  return {
    isPersonalProfile,
    showCitizenshipData,
    showChosenFirstName,
    showChosenLastName,
    showAcademicTitle,
    showPrivateEmailAddress,
  }
}
